import ReactGA from 'react-ga4';

// GA4 측정 ID
const GA_MEASUREMENT_ID = 'G-W29Q7K7H0M';

// GA4 초기화
export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    debug: process.env.NODE_ENV === 'development'
  });
};

// 페이지뷰 추적
export const trackPageView = path => {
  ReactGA.send({
    hitType: 'pageview',
    page: path
  });
};

// 이벤트 추적
export const trackEvent = (eventName, parameters = {}) => {
  ReactGA.event(eventName, parameters);
};

// 사용자 속성 설정
export const setUserProperties = properties => {
  ReactGA.set(properties);
};
